import React, { useEffect, useState } from 'react'
import GetMovieCollectionByIDService from '../../Services/Queries/GetMovieCollectionByIDService'
import GetMovieListsByMovieCollectionIDService from '../../Services/Queries/GetMovieListsByMovieCollectionIDService'
import ListHeaderLevelTaggedPersonsInMovieCollectionService from '../../Services/Queries/ListHeaderLevelTaggedPersonsInMovieCollectionService'
import CrudCreateList from './CrudCreateList'

export default function EditMovieCollection() {
  const [response, setResponse] = useState({})
  const [movieCollectionIDSData, setMovieCollectionIDSData] = useState()
  const [headerLevel, setHeaderLevel] = useState([])
  const getData = async () => {
    const url = window.location.href.split('?')
    const input = {
      movieCollectionID: decodeURIComponent(url[1]).replace('$', '#'),
    }
    const response = await GetMovieCollectionByIDService(input)
    setResponse(response)
    const MovieCollectionIDServiceInput = {
      movieCollectionID: decodeURIComponent(url[1]).replace('$', '#'),
      limit: 100,
    }
    const MovieCollectionIDSData = await GetMovieListsByMovieCollectionIDService(
      MovieCollectionIDServiceInput,
    )
    const headerLevelTemp = await ListHeaderLevelTaggedPersonsInMovieCollectionService(
      MovieCollectionIDServiceInput,
    )
    setHeaderLevel(headerLevelTemp.items ? headerLevelTemp.items : [])

    setMovieCollectionIDSData(MovieCollectionIDSData.items)
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
    if (!document.hidden && !movieCollectionIDSData) {
      getData()
      }
    }

      document.addEventListener('visibilitychange', handleVisibilityChange)

      // Fetch data when the component is mounted
      if (!movieCollectionIDSData) {
      getData()
      }

      // Cleanup the event listener when the component unmounts
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
  }, [movieCollectionIDSData])
  return (
    <CrudCreateList
      mode={'edit'}
      response={response}
      movieCollectionIDSData={movieCollectionIDSData}
      headerLevel={headerLevel}
    />
  )
}
